<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <inline-svg :src="require('@/assets/svg/clock_blue.svg')" width="25" />
      Request Reschedule
    </SecondaryButton>
    <EditInterviewParticipantStatusDialog
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
      title="Why do you want to reschedule this interview?"
      buttonText="Request Reschedule"
      status="reschedule"
    />
  </BaseAction>
</template>

<script>
import EditInterviewParticipantStatusDialog from "@/views/interviews/dialogs/EditInterviewParticipantStatusDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "RequestRescheduleInterviewAction",
  components: {
    BaseAction,
    SecondaryButton,
    EditInterviewParticipantStatusDialog,
    InlineSvg
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
